export default "__VITE_ASSET__Dt5boqC0__"